import { Shop } from "@/features/shop/models/Shop";

export interface PromotionCheckForm {
  shop?: Shop;
  date: string | Date;
  selectedChannel?: number;
  selectedItems: PromotionItemForm[];
  totalPrice: number;
}

export interface PromotionItemForm {
  id?: number;
  name: string;
  sku: string;
  quantity: number;
  price?: number;
  status: PromotionItemStatus;
}

export enum PromotionItemStatus {
  Init,
  Loading,
  Success,
  Fail
}
